import React from 'react';
import { ArrowRightIcon, ScanSearchIcon, MessageSquareTextIcon, ArrowLeftRightIcon, ClipboardCheckIcon } from 'lucide-react';
import { expertiseRows } from '../data/homepage';
const icons = {
  stand: ScanSearchIcon,
  capture: MessageSquareTextIcon,
  connect: ArrowLeftRightIcon,
  changed: ClipboardCheckIcon
} as const;
export function ExpertiseSection() {
  return <section aria-labelledby="expertise-title" className="bg-mint" data-id="element-59" data-mp="pshrowxwpm0p">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-5 py-12 md:gap-10 md:px-8 md:py-16 lg:grid-cols-[minmax(0,4fr)_minmax(0,6fr)] lg:gap-16" data-id="element-60" data-mp="puu998zr5ud8">
        <div data-id="element-61" data-mp="zr7acrxmnai0">
          <h2 id="expertise-title" className="max-w-[520px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-62" data-mp="zrp67ngdnmpe">
            Our expertise puts AI to work for you.
          </h2>
          <p className="mt-5 max-w-[500px] text-[17px] leading-[1.6] text-ink/85" data-id="element-63" data-mp="2b49h6v9xcloz">
            Our team sets the strategy. We use AI to research more thoroughly,
            make improvements faster, and get more done for your business. We
            direct the work, check the quality, and stay accountable for the results.
          </p>
          <p className="mt-4 text-[17px] font-semibold leading-[1.6] text-ink" data-id="element-64" data-mp="h0p3mlxbccq1">
            Fewer missed leads. Less manual work.
          </p>
          <a href="#contact" className="mt-5 inline-flex min-h-11 items-center gap-2 text-[16px] font-bold text-ink underline decoration-brand-orange decoration-2 underline-offset-[6px] transition-colors duration-150 ease-out hover:decoration-ink" data-id="element-65" data-mp="l0pvb89fakf1">
            Talk through your goals
            <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-66" data-mp="3tg9etfkakogw" />
          </a>
        </div>

        <ul className="grid content-start gap-x-8 gap-y-6 sm:grid-cols-2 md:gap-y-8" data-id="element-67" data-mp="24pwbdi12gly">
          {expertiseRows.map(row => {
          const Icon = icons[row.id as keyof typeof icons];
          return <li key={row.id} className="min-w-0 border-t border-mint-line pt-5" data-id="element-68" data-mp="35q5fhke4zavp">
                <div className="flex items-start gap-3" data-id="element-69" data-mp="cw6vq5qa6ok4">
                  <Icon className="h-6 w-6 shrink-0 text-brand-greenDeep" strokeWidth={1.75} aria-hidden data-id="element-70" data-mp="7z6pnutfllt0" />
                  <h3 className="text-[18px] font-bold leading-snug text-ink" data-id="element-71" data-mp="mnui3s7zdfeq">{row.title}</h3>
                </div>
                <p className="mt-3 text-[16px] leading-[1.6] text-ink/85" data-id="element-72" data-mp="hpsy952qdc27">
                  {row.body}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}